import type { UsersState } from 'shared/interfaces/users.interface';

import { createSlice } from '@reduxjs/toolkit';

import { getUsersThunk, getUserThunk } from './users.thunks';

const initialState: UsersState = {
  list: [],
  current: null,
  totalPages: 0,
  isGetUsersThunkPending: false,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    removeUserFromStore: (state) => {
      state.current = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsersThunk.pending, (state) => {
        state.isGetUsersThunkPending = true;
      })
      .addCase(getUsersThunk.fulfilled, (state, action) => {
        state.list = action.payload.rows;
        state.totalPages = action.payload.totalPages;
        state.isGetUsersThunkPending = false;
      })
      .addCase(getUsersThunk.rejected, (state) => {
        state.isGetUsersThunkPending = false;
      });

    builder.addCase(getUserThunk.fulfilled, (state, action) => {
      state.current = action.payload;
    });
  },
});

export const { removeUserFromStore } = usersSlice.actions;

export const usersReducer = usersSlice.reducer;
